import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

if (!baseURL) {
  // Fail loud in dev so misconfiguration is obvious.
  // eslint-disable-next-line no-console
  console.warn("[api] REACT_APP_BACKEND_URL is not set");
}

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export default api;
